import { CTABlock } from '@/components/blocks/CTABlock';
import { CTAProps } from '@/components/CTA';
import { Typography } from '@eventbrite/marmalade';
import { SymbolAlertCircleIcon } from '@eventbrite/marmalade/icons';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './FallbackUI.module.scss';

interface FallbackUIProps {
  homeUrl: string;
}
/**
 * This is a fallback UI that handles 5xx errors
 * It displays a message and a button to return to the home page
 */
export const FallbackUI: React.FC<FallbackUIProps> = ({ homeUrl }) => {
  const { formatMessage } = useIntl();

  const ctas: CTAProps[] = [
    {
      label: formatMessage({
        id: 'Create An Event',
        defaultMessage: 'Create An Event',
        description: 'Button text to create an event',
      }),
      link: `${homeUrl}create`,
      type: 'primary',
    },
    {
      label: formatMessage({
        id: 'Find An Event',
        defaultMessage: 'Find An Event',
        description: 'Button text to find an event',
      }),
      link: `${homeUrl}directory`,
      type: 'secondary',
    },
  ];

  return (
    <div className={styles.fallback_ui}>
      <SymbolAlertCircleIcon size="3XL" color="var(--marm-color-action-fg-base)" />
      <Typography as="h1" variant="heading-lg" className={styles.message}>
        {formatMessage({
          id: 'Oops! Something went wrong, please try again later',
          defaultMessage: 'Oops! Something went wrong, please try again later',
          description: 'Message displayed when an error occurs',
        })}
      </Typography>
      <CTABlock ctas={ctas} />
    </div>
  );
};
